import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import config from "../../config";

function RequestsModal({ onClose }) {
  const { instance, accounts } = useMsal();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchRequests() {
      try {
        const tokenResponse = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });

        const managerEmail = accounts[0]?.username;
        const response = await fetch(`/api/getRequests?managerEmail=${encodeURIComponent(managerEmail)}`, {
          headers: { Authorization: `Bearer ${tokenResponse.accessToken}` }
        });

        if (!response.ok) throw new Error(`API error: ${response.status}`);
        const data = await response.json();
        setRequests(data);
      } catch (err) {
        console.error('Error fetching requests:', err);
        setError('Unable to load requests.');
      } finally {
        setLoading(false);
      }
    }
    fetchRequests();
  }, [instance, accounts]);

  const overlayStyle = { position:"fixed", inset:0, background:"rgba(24,7,58,0.4)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:100, backdropFilter:"blur(4px)" };
  const thStyle = { textAlign:"left", padding:"8px 10px", fontSize:"9px", fontWeight:700, color:"#b0adc8", textTransform:"uppercase", letterSpacing:"0.08em", borderBottom:"0.5px solid #f0f0ef" };

  return (
    <div style={overlayStyle} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background:"#fff", borderRadius:"10px", padding:"28px", width:"600px", boxShadow:"0 20px 60px rgba(24,7,58,0.2)" }}>
        <div style={{ fontSize:"16px", fontWeight:700, color:"#18073a", marginBottom:"3px" }}>Requests</div>
        <div style={{ fontSize:"12px", color:"#79749c", marginBottom:"22px" }}>A log of requests raised from this portal</div>

        {loading && (
          <div style={{ textAlign:"center", padding:"20px", fontSize:"12px", color:"#79749c" }}>Loading...</div>
        )}

        {error && (
          <div style={{ fontSize:"12px", color:"#82162d", marginBottom:"16px" }}>{error}</div>
        )}

        {!loading && !error && requests.length === 0 && (
          <div style={{ textAlign:"center", padding:"20px", fontSize:"12px", color:"#79749c" }}>No requests raised yet.</div>
        )}

        {!loading && !error && requests.length > 0 && (
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"12px" }}>
            <thead>
              <tr>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Contractor</th>
                <th style={thStyle}>Action</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Ticket</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((r, i) => (
                <tr key={i}>
                  <td style={{ padding:"10px", color:"#b0adc8", fontSize:"11px", borderBottom:"0.5px solid #f5f5f3" }}>{r.date}</td>
                  <td style={{ padding:"10px", fontWeight:600, borderBottom:"0.5px solid #f5f5f3" }}>{r.contractor}</td>
                  <td style={{ padding:"10px", color:"#4d4777", borderBottom:"0.5px solid #f5f5f3" }}>{r.action}</td>
                  <td style={{ padding:"10px", borderBottom:"0.5px solid #f5f5f3" }}>
                    <span style={{ fontSize:"11px", fontWeight:600, color: r.resolved ? "#2d6a4f" : "#b8860b" }}>
                      {r.resolved ? "Resolved/Closed" : "Unresolved"}
                    </span>
                  </td>
                  <td style={{ padding:"10px", borderBottom:"0.5px solid #f5f5f3" }}>
                    <a href={`https://${config.freshserviceDomain}/helpdesk/tickets/${r.ticketNumber.replace('SR-','')}`} target="_blank" rel="noreferrer" style={{ color:"#498ca7", textDecoration:"none", fontWeight:600 }}>{r.ticketNumber}</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div style={{ display:"flex", justifyContent:"flex-end", marginTop:"22px", paddingTop:"18px", borderTop:"0.5px solid #f0f0ef" }}>
          <button onClick={onClose} style={{ padding:"9px 16px", fontSize:"12px", fontWeight:600, color:"#79749c", background:"#f0f0ef", border:"none", borderRadius:"6px", cursor:"pointer", fontFamily:"Montserrat, sans-serif" }}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default RequestsModal;